import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DwComponent, DwComponentType, DwSecurityUserService, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwMessage, DwEventService, DwMdEventService, DwMdEventType, areEqual } from '@devwareapps/devware-cap';
import { subsetDependencies } from 'mathjs';
import { Observable, Subject, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { WachterUserExt } from '../../../../shared/models/wachter-user.model';
import { CovidMetaDataService, EmployeeSummaryEntity, CovidMetaDataItemNames, EmployeeTestEntity } from '../../meta-data/covid-meta-data.service';


@DwComponent({
  key:'employeeCovidSummary',
  name: 'Employee Covid Summary',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-covid-employee-summary',
  template: 
    `<div *ngIf="employeeSummary">
      <dw-meta-data-form #mdForm item="EmployeeSummary" overrideData="true"  [data]="employeeSummary" configKeyPart="employee-covid-sumamry" formMode="view" >
      </dw-meta-data-form>
    </div>`
})
export class CovidEmployeeSummaryComponent implements OnInit, OnDestroy{
  employeeSummary: EmployeeSummaryEntity;
  subscriptions: Subscription[] = [];

  constructor(
    private dwSecurityUserService: DwSecurityUserService,
    private dwEventService: DwEventService,
    private dwMdEventService: DwMdEventService,
    @Inject(DwOrmDataServiceToken) private DwOrmDataService: DwOrmDataService   
    ) {}

  ngOnDestroy(): void {
    for(const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.dwSecurityUserService.securityContextChanged().subscribe(() => {
      this.employeeSummary = null;

      this.loadEmployeeSummary();
    });

    this.loadEmployeeSummary();

    this.setupEmployeeTestSubscription();
  }

  private setupEmployeeTestSubscription() {
    let lastEmployeeSummary: EmployeeSummaryEntity;

    this.subscriptions.push(this.dwMdEventService.getUpdateEvents<EmployeeTestEntity>(CovidMetaDataItemNames.EmployeeTest)
      .subscribe(event => {
          if (event?.newItem?.EmployeeUserId == this.employeeSummary?.EmployeeUserId) {
             this.refreshEmployeeSummary(this.employeeSummary);
          }
      }));
  }

  private refreshEmployeeSummary(lastEmployeeSummary: EmployeeSummaryEntity,count: number = 0, ) {
    
    if (count > 10) {
      return;
    }

    setTimeout(() => {
      this.loadEmployeeSummary()
        .subscribe(summary => {
          if (areEqual(lastEmployeeSummary, summary)) {
            this.refreshEmployeeSummary(lastEmployeeSummary, count + 1);
          }
        })
    },3000);
  }

  private loadEmployeeSummary():Observable<EmployeeSummaryEntity> {
    const subject = new Subject<EmployeeSummaryEntity>();
    const md = new CovidMetaDataService();
    const qh = new DwQueryHelper();

    const trustUserId = this.getTrustUserId();

    if (!trustUserId) {

      setTimeout(() => {
        subject.next(null);
      });

      return subject.asObservable();
    }

    var query = md.EmployeeSummary.CreateQuery()
      .AddFilterAnd(qh.filters.Equal(md.EmployeeSummary.EmployeeUserId, trustUserId))
      .AddPrefetchPath(md.EmployeeSummary.Relations.EmployeeTestByLastEmployeeTestId);
    
    // this.employeeSummary = null;
    this.DwOrmDataService.executeQuerySingle(query)
      .subscribe(result => {

        //if (!areEqual(this.employeeSummary, result)) {
          this.employeeSummary = result;
        //}
        
        subject.next(this.employeeSummary);
      });

    return subject.asObservable();
  }

  private getTrustUserId() {
    const user = this.dwSecurityUserService.securityContext.ApplicationUser;

    if (user) {
      const wachterUser = new WachterUserExt(user);

      return wachterUser.trustUserId;
    }

    return null;
  }
  
}
